import { useEffect, useState } from 'react';
import { getSubscribableProducts } from '../../services/subscription';
import { hasBoxSubscription } from '../../utils/subscriptions';

const useActiveSubscriptionState = (): boolean => {
  const [activeSubscription, setActiveSubscription] = useState(false);
  useEffect(() => {
    const fetchActiveSubscription = async () => {
      const subscriptionResponse = await getSubscribableProducts();
      setActiveSubscription(hasBoxSubscription(subscriptionResponse));
    };
    fetchActiveSubscription();
  }, []);
  return activeSubscription;
};

export default useActiveSubscriptionState;
